const SearchIndexFilename = "search_index.json";

module.exports = {
     SearchIndexFilename
};